// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrustBadges-block-uEMBl {
  --green: #16a34a;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
}

.TrustBadges-heading-QbgWt {
  font-size: clamp(24px, 4vw, 34px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 32px;
}

.TrustBadges-grid-bHgS5 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.TrustBadges-card-bdpiN {
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 24px 22px;
  background: #fff;
  text-align: center;
  -webkit-transition: border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, border-color 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
}

.TrustBadges-card-bdpiN:hover {
  -webkit-transform: translateY(-3px);
      -ms-transform: translateY(-3px);
          transform: translateY(-3px);
  border-color: #bfe6d3;
  -webkit-box-shadow: 0 16px 36px rgba(15, 18, 20, 0.07);
          box-shadow: 0 16px 36px rgba(15, 18, 20, 0.07);
}

.TrustBadges-ic-DhHPQ {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: #e4f6f3;
  color: var(--green);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin: 0 auto 16px;
}

.TrustBadges-ic-DhHPQ svg {
  width: 28px;
  height: 28px;
}

.TrustBadges-title-TMUOt {
  font-size: 17px;
  font-weight: 800;
  margin: 0 0 8px;
}

.TrustBadges-text-_aulD {
  font-size: 14px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0;
}

@media (max-width: 900px) {
  .TrustBadges-grid-bHgS5 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 520px) {
  .TrustBadges-grid-bHgS5 {
    grid-template-columns: 1fr;
  }
}

@media (prefers-color-scheme: dark) {
  .TrustBadges-block-uEMBl,
  .TrustBadges-heading-QbgWt,
  .TrustBadges-title-TMUOt {
    color: #f3f4f6;
  }
  .TrustBadges-card-bdpiN {
    background: #1d2125;
    border-color: #2c3137;
  }
  .TrustBadges-text-_aulD {
    color: #9aa3ad;
  }
  .TrustBadges-ic-DhHPQ {
    background: rgba(22, 163, 74, 0.16);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/marketing/TrustBadges.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yFAAiE;EAAjE,iFAAiE;EAAjE,iEAAiE;EAAjE,oHAAiE;AACnE;;AACA;EACE,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,qBAAqB;EACrB,sDAA8C;UAA9C,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;IAGE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,cAAc;EAChB;EACA;IACE,mCAAmC;EACrC;AACF","sourcesContent":[".block {\n  --green: #16a34a;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n}\n\n.heading {\n  font-size: clamp(24px, 4vw, 34px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 32px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 18px;\n}\n\n.card {\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 24px 22px;\n  background: #fff;\n  text-align: center;\n  transition: transform 0.16s, box-shadow 0.16s, border-color 0.16s;\n}\n.card:hover {\n  transform: translateY(-3px);\n  border-color: #bfe6d3;\n  box-shadow: 0 16px 36px rgba(15, 18, 20, 0.07);\n}\n\n.ic {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: #e4f6f3;\n  color: var(--green);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n}\n.ic svg {\n  width: 28px;\n  height: 28px;\n}\n\n.title {\n  font-size: 17px;\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n.text {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0;\n}\n\n@media (max-width: 900px) {\n  .grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 520px) {\n  .grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .block,\n  .heading,\n  .title {\n    color: #f3f4f6;\n  }\n  .card {\n    background: #1d2125;\n    border-color: #2c3137;\n  }\n  .text {\n    color: #9aa3ad;\n  }\n  .ic {\n    background: rgba(22, 163, 74, 0.16);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `TrustBadges-block-uEMBl`,
	"heading": `TrustBadges-heading-QbgWt`,
	"grid": `TrustBadges-grid-bHgS5`,
	"card": `TrustBadges-card-bdpiN`,
	"ic": `TrustBadges-ic-DhHPQ`,
	"title": `TrustBadges-title-TMUOt`,
	"text": `TrustBadges-text-_aulD`
};
module.exports = ___CSS_LOADER_EXPORT___;
